module.exports = __webpack_public_path__ + "static/media/velour12B.31b127d4.jpg";